import React from 'react';
import ReportViewer from "./base/ReportViewer";

const ListeMembres = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"ListeMembres"}/>
        </div>
    );
}
export default ListeMembres;